import React, { useEffect, Component } from "react";

import moment from "moment";
import { toJS } from "mobx"
import { observer } from "mobx-react";
import AuthStore from "modules/login/store/AuthStore"

import { Collapse } from "../../../../components";
import ProductTabComponent from "../optimization-card/ProductTabComponent";
import AllProducts from "../optimization-card/all-products";
import { Image } from "react-bootstrap";
import * as images from "constants/Images";
import getFamilyMemberNameFromFamilyObject from "utils/getFamilyMemberNameFromFamilyObject";
import OptimizationStore from "modules/optimization/store/OptimizationStore";
import TotalPremium from "modules/choose-needs/components/total-premium/TotalPremium";
import Utils from "./utils";
import NeedTypeEnum from "constants/NeedTypeEnum";
import ChangeProductReasonModal from 'modules/family-protection/components/change-product-reason-modal/ChangeProductReasonModal';
import ChangeProductModal from 'modules/family-protection/components/change-product-modal/ChangeProductModal';
import isObjectEmpty from "modules/choose-needs/components/form/retirement-calculator/isObjectEmpty";
import CustomizationLoader from "components/ui/customization-loader/CustomizationLoader";
import { EMPLOYER_EMPLOYEE_SCHEME_A, HUF, KEYMAN, PARTNERSHIP } from "constants/ CustomerType";
import { CHANGE_LA_CUSTOMIZATION, CHANGE_PR_CUSTOMIZATION } from "constants/UserClicksConstant";
import StorageKeys from "constants/StorageKeys";
import { BANCA_JOURNEY } from "constants/Constants";
import getCookieValue from "utils/getCookieValue/getCookieValue";
import { ELIGIBLE_SECONDARY_LA_PRODUCT } from "constants/Constants";
const MemberCard = observer(
  class MemberCard extends Component {
    state = {
      productName: '',
      showModalBackDrop: false,
      riskType: '',
      showAddLABtn: false,
      openCollapse: false,
      familyProductID: '',
      isCollpaseOpen: true,
    }

    toggleCollapse = (value) => {
      this.setState({ isCollpaseOpen: value })
    }

    capitalize = (str) => {
      if (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
      }
      return "";
    };

    componentDidMount() {
      const { data, open } = this.props;
      let removedData = this.fetchRemovedData()
      this.setState({ productName: data.product_name, isProductDisabled: removedData.laRemoved || removedData.isRemoved, showAddLABtn: removedData.laRemoved, openCollapse: open && !removedData.laRemoved });
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevProps.disabled !== this.props.disabled || prevProps.showAddLA !== this.props.showAddLA || prevProps.open !== this.props.open || prevState.riskType !== this.state.riskType) {
        let removedData = this.fetchRemovedData()
        this.setState({ isProductDisabled: this.props.disabled, showAddLABtn: removedData.laRemoved, openCollapse: this.props.open && !removedData.laRemoved });

        if (removedData.laRemoved || this.props.isNeedDisabled) {
          this.setState({ isCollpaseOpen: false })
        } else {
          this.setState({ isCollpaseOpen: true })
        }
      }
    }

    fetchRemovedData = () => {
      const { data } = this.props;
      const { family_product_details_list: totalFamilyProductsList, journey_need: journeyNeed } = toJS(AuthStore.journeyData)
      let laRemoved = false
      let isRemoved = false
      if (Array.isArray(data.BI) && this.state.riskType) {
        const productData = data.BI.find((item) => item.risk === this.state.riskType)
        const product = totalFamilyProductsList.find(product => product.id === productData.family_product_id)
        laRemoved = product && product?.la_removed && product?.la_removed === true
        isRemoved = product && journeyNeed.find(item => item.need === product?.need)?.is_removed || false
      } else {
        const product = totalFamilyProductsList.find(product => product.id === data.family_product_id)
        laRemoved = product && product?.la_removed && product?.la_removed === true
        isRemoved = product && journeyNeed.find(item => item.need === product?.need)?.is_removed || false
      }
      return { laRemoved: laRemoved, isRemoved: isRemoved }
    }

    getAge = (dob) => {
      let age = 0;
      if (dob) {
        age = moment().diff(moment(dob), "years");
      }
      return age;
    };

    showBackDropFunction = () => {
      this.setState({ showModalBackDrop: true })
    }

    hideBackDropFunction = () => {
      this.setState({ showModalBackDrop: false })
    }

    riskTypeFunction = (selectedTab) => {
      OptimizationStore.fetchIndividualProductTimeLineReqParam = { "family_product_id": this.state.familyProductID, "risk_type": selectedTab.split(' ')[0].toLowerCase() }
      this.setState({ riskType: selectedTab.split(' ')[0].toLowerCase() })
    }

    changeProposerDetailsDisabled() {
      let changeProductDisabled = false
      let source_system = getCookieValue("source")
      if (this.props.cardKey === NeedTypeEnum.PROTECTION_FOR_MY_FAMILY || source_system === BANCA_JOURNEY) {
        changeProductDisabled = true
      } else if (this.props.cardKey === NeedTypeEnum.PROTECTION_FOR_MY_HEALTH) {
        changeProductDisabled = ![5, 7].includes(this.props.data.life_assured_details.occupation)
      } else {
        changeProductDisabled = this.props.data.BI.some((item) => !item.update_BI)
      }

      //If Employer Employee Scheme A, HUF, Partnership and Keyman Customer Type selected.
      if (AuthStore?.journeyTypeName?.toString() === EMPLOYER_EMPLOYEE_SCHEME_A || AuthStore?.journeyTypeName?.toString() === HUF || AuthStore?.journeyTypeName?.toString() === PARTNERSHIP || AuthStore?.journeyTypeName?.toString() === KEYMAN) {
        changeProductDisabled = true
      }

      return changeProductDisabled
    }


    infoMessageFunction = (title, laName) => {
      if (title === "Protection for my Family" || title === "Protection for my Health") {
        const familyId = this.props.data.id

        const { family_details_list: totalFamilyProductsList } = toJS(AuthStore.journeyData)

        let currentLifeCoverID = totalFamilyProductsList.find(member => member.id === familyId)?.current_life_cover

        let lifeCoverDetails = toJS(AuthStore.lifeCoverList)

        const noLifeCoverValue = lifeCoverDetails.find(singleCover => singleCover.label === "No Life Cover")

        if (noLifeCoverValue.id === currentLifeCoverID) {
          return `Sorry! We don't have a suitable product for ${laName}`
        } else {
          return `${laName.slice(0, -2)} is sufficiently covered.`
        }
      }
    }

    newshowSecondaryLA = (data) => {
      if (data?.BI.length > 0) {
        return (
          data?.BI?.some(({ product_name, bi_request }) =>
            ELIGIBLE_SECONDARY_LA_PRODUCT.includes(product_name) &&
            data?.selectedRisk === "medium" &&
            Utils.checkPlanOptionForSecLA(product_name, bi_request)
          ) || false
        );
      } else {
        return false
      }
    };

    houseWifeMsg = () => {
      const { data } = this.props;
      const journeyData = toJS(AuthStore.journeyData);
      let houseWifeMemberList = journeyData.family_details_list.filter((item) => Number(item.occupation) === 5)

      let isValidationExist = false
      let proposerExist = houseWifeMemberList.some((item) => data.proposer_details.id === item.id && (data.proposer_details.family_member_type.toLowerCase() == "self" || data.proposer_details.family_member_type.toLowerCase() == "spouse"))
      let laExist = houseWifeMemberList.some((item) => data.life_assured_details.id === item.id)

      if (proposerExist && !laExist) {
        isValidationExist = true
      }
      return isValidationExist
    }

    disabledFunctionalityOpt() {
      if (Array.isArray(this.props.data.BI)) {
        return this.props.data.BI.some((item) => !item.update_BI)
      } else {
        return !this.props.data?.update_BI
      }
    }

    render() {
      const { index, disabled, open, onChange, data, cardKey, onAddMember, onAddInsured, getProposerList, showAddLA, title } = this.props;
      const { isProductDisabled, showAddLABtn, openCollapse } = this.state
      const age = this.getAge(data.dob);
      let ddd = data

      const proposerDetails = data.proposer_details;

      const lifeAssuredDetails = data.life_assured_details;
      const secondaryLifeAssuredDetails = data.secondary_la_Details
      let productName = data.product_name;
      let productId = data.product_id;
      console.log("MEMBERCARD", data)

      let isErrorExist = data.isErrorExist
      let familyProductId = data.family_product_id;
      let pasaCampaignProduct = sessionStorage.getItem(StorageKeys.IS_PASA_PRODUCT) === "true" ? true : false

      const proposerAge = this.getAge(proposerDetails.dob);
      const proposerName = getFamilyMemberNameFromFamilyObject(proposerDetails);
      const lifeAssuredName = getFamilyMemberNameFromFamilyObject(lifeAssuredDetails);
      const secondaryLifeAssuredName = getFamilyMemberNameFromFamilyObject(secondaryLifeAssuredDetails)
      const secondaryLifeAssuredAge = this.getAge(secondaryLifeAssuredDetails?.dob)
      const paymenOptionPR = proposerDetails?.payment_option

      const lifeAssuredType = lifeAssuredDetails.family_member_type
      pasaCampaignProduct ? OptimizationStore.setPasaLifeAssuredType(lifeAssuredType) : OptimizationStore.setPasaLifeAssuredType('')

      let productIdArray;
      if (Array.isArray(this.props.data.BI)) {
        productIdArray = this.props.data.BI.map((singleProduct) => singleProduct.product_id);
      } else {
        productIdArray = [this.props.data.product_id];
      }

      let productData = data;
      let biResponse = productData.parsedResponse;
      let firstYearResponse = productData.firstYearResponse;
      let biRequest = productData.bi_request;
      let totalPremium = false;
      if (biRequest && firstYearResponse) {
        totalPremium = Utils.calcualateTotalPremiumComponentData(firstYearResponse, biResponse, biRequest, productName, productData);
      }

      // ! logic for total premium for tab 
      if (Array.isArray(productData.BI)) {

        // !data => parsedResponse,firstYearResponse (for zindagi plus)
        // !data => BI => [{parsedResponse,firstYearResponse},{parsedResponse,firstYearResponse},{parsedResponse,firstYearResponse}] (for wealthGainPlus)

        let RiskIndex
        // this risk index is not in sync wit bi response data of productData?.BI but is used for making total premium component show correct data.
        switch (this.state.riskType) {
          case 'low':
            RiskIndex = 0
            break;

          case 'medium':
            RiskIndex = 1
            break;

          case 'high':
            RiskIndex = 2
            break;

          default:
            break;
        }

        productName = productData?.BI[RiskIndex]?.product_name
        productId = productData?.BI[RiskIndex]?.product_id
        isErrorExist = productData?.BI[RiskIndex]?.isErrorExist
        familyProductId = productData?.BI[RiskIndex]?.family_product_id

        if (this.state.familyProductID !== familyProductId) {
          this.setState((preState) => {
            if (preState.familyProductID !== familyProductId) {
              return { familyProductID: familyProductId }
            }
          })
        }

        const biResponse = productData?.BI[RiskIndex]?.parsedResponse
        const biRequest = productData?.BI[RiskIndex]?.bi_request
        const firstYearResponse = productData?.BI[RiskIndex]?.firstYearResponse

        totalPremium = Utils.calcualateTotalPremiumComponentData(firstYearResponse, biResponse, biRequest, productName, productData);
      }

      return (
        <>
          <Collapse
            key={index}
            isNeedDisabled={this.props.isNeedDisabled}
            keyIndex={index}
            toggleCollapse={this.toggleCollapse}
            showAddLA={this.props.showAddLA}
            disabled={isProductDisabled}
            open={this.state.isCollpaseOpen}
            onChange={onChange}
            hideBackDropFunction={!isProductDisabled}
            showModalBackDrop={isProductDisabled || this.state.showModalBackDrop}
            addLA={() => this.props.addLA(productName, familyProductId, cardKey)}
            title={
              this.state.isCollpaseOpen ? (
                <div className='d-flex flex-column flex-md-row justify-content-between' style={{ maxWidth: "900px" }}>
                  <div className={`select-deselect-btn align-self-center ${disabled ? "text-gray" : "text-description-text-color"}`}>
                    <div className='d-flex flex-wrap align-items-center'>
                      <p className='font-size-14 mb-0 mr-1'>Primary Life Assured:</p>
                      <p className={`font-weight-bold font-size-16 mr-md-1 mb-0 order-3 order-lg-1 ${disabled ? "text-gray" : "text-secondary"}`}>
                        {lifeAssuredName}
                        <span className='text-dark ml-1 mb-0'>
                          {age}
                          <span className='font-weight-light ml-1 mb-0'>yrs</span>
                        </span>
                      </p>
                      <button
                        className='btn text-primary p-0 LA-btn font-size-14 font-size-md-12 font-weight-light mr-2 order-1 order-lg-2'
                        onClick={() => {
                          //! for save user clicks
                          AuthStore.saveUserClicks(CHANGE_LA_CUSTOMIZATION)
                          OptimizationStore.setSelectedNeed(cardKey);
                          let secondary_la_product = this.newshowSecondaryLA(data, this.state.riskType)
                          let selectedRiskDetails = data?.BI instanceof Array ? data?.BI?.find(item => item?.risk === this.state.riskType) : undefined;
                          OptimizationStore.getEligibleLaList(productIdArray, cardKey, lifeAssuredType, secondary_la_product, "primary", selectedRiskDetails?.bi_request?.packageId ? selectedRiskDetails?.bi_request?.packageId : "", selectedRiskDetails?.bi_request);
                          // OptimizationStore.getEligibleLaList(productIdArray, cardKey, lifeAssuredType);
                          OptimizationStore.setSelectedNeedCardData(data)
                        }}
                        disabled={this.disabledFunctionalityOpt() || pasaCampaignProduct}
                      >
                        [<Image width='12' className='mx-1' src={images.EditIconLink} alt='back-arrow' /> Change LA ]
                      </button>

                      <button
                        className='btn text-primary p-0 LA-btn font-size-14 font-size-md-12 font-weight-light order-2 order-lg-3'
                        onClick={() => this.props.removeLA(productName, familyProductId)}
                        disabled={this.disabledFunctionalityOpt() || pasaCampaignProduct}
                      >
                        [<Image width='10' className='mx-1' src={images.CloseIconLink} alt='back-arrow' />
                        Remove LA ]
                      </button>
                    </div>
                  </div>

                  {this.newshowSecondaryLA(data) &&

                    <div className={`select-deselect-btn align-self-center ${disabled ? "text-gray" : "text-description-text-color"}`}>
                      <div className='d-flex flex-wrap align-items-center'>
                        <p className='font-size-14 mb-0 mr-1'>Secondary Life Assured:</p>
                        <p className={`font-weight-bold font-size-16 mr-md-1 mb-0 order-3 order-lg-1 ${disabled ? "text-gray" : "text-secondary"}`}>
                          {secondaryLifeAssuredName}
                          <span className='text-dark ml-1 mb-0'>
                            {secondaryLifeAssuredAge}
                            <span className='font-weight-light ml-1 mb-0'>yrs</span>
                          </span>
                        </p>
                        <button
                          className='btn text-primary p-0 LA-btn font-size-14 font-size-md-12 font-weight-light mr-2 order-1 order-lg-2'
                          onClick={() => {
                            //! for save user clicks
                            AuthStore.saveUserClicks(CHANGE_LA_CUSTOMIZATION)
                            OptimizationStore.setSelectedNeed(cardKey);
                            let secondary_la_product = this.newshowSecondaryLA(data, this.state.riskType)
                            let selectedRiskDetails = data?.BI?.find(item => item?.risk === this.state.riskType)
                            OptimizationStore.getEligibleLaList(productIdArray, cardKey, lifeAssuredType, secondary_la_product, "secondary", selectedRiskDetails?.bi_request?.packageId, selectedRiskDetails?.bi_request);
                            OptimizationStore.setSelectedNeedCardData(data)
                          }}
                          disabled={this.disabledFunctionalityOpt() || pasaCampaignProduct}
                        >
                          [<Image width='12' className='mx-1' src={images.EditIconLink} alt='back-arrow' /> Change Secondary LA ]
                        </button>
                      </div>
                    </div>
                  }

                  <div className='d-none d-md-block border-right border-dark mx-md-4'></div>

                  <div className={`mt-3 mt-md-0 select-deselect-btn ${disabled ? "text-gray" : "text-description-text-color"}`}>
                    <div className='d-flex flex-wrap align-items-center'>
                      <p className='font-size-14 mr-1 mb-0'>Proposer:</p>
                      {Object.keys(proposerDetails).length === 0 ?
                        <CustomizationLoader />
                        : <p className={`font-weight-bold font-size-16 mr-1 mb-0 order-2 order-lg-1 ${disabled ? "text-gray" : "text-dark"}`}>
                          {proposerName}
                          <span className='text-dark'>
                            {" "}
                            {proposerAge}
                            <span className='font-weight-light ml-1'>yrs</span>
                          </span>
                        </p>}

                      <button
                        className={`btn p-0 LA-btn font-size-12 font-weight-light mr-2 order-1 order-lg-2 ${this.changeProposerDetailsDisabled() ? 'text-gray' : 'text-primary'}`}
                        onClick={() => {
                          //! for save user clicks
                          AuthStore.saveUserClicks(CHANGE_PR_CUSTOMIZATION)

                          OptimizationStore.getEligibleProposerList(productIdArray, cardKey, data.id);
                          OptimizationStore.setSelectedNeedCardData(data);
                        }}
                        disabled={this.changeProposerDetailsDisabled()}
                      >
                        [
                        <Image width='12' className='mx-1' src={images.EditIconLink} alt='back-arrow' />
                        Change Proposer ]
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className='d-flex flex-column flex-md-row justify-content-between' style={{ maxWidth: "900px" }}>
                  <div className={`select-deselect-btn align-self-center ${disabled ? "text-gray" : "text-description-text-color"}`}>
                    <div className='d-flex flex-wrap align-items-center'>
                      <p className={`font-weight-bold font-size-16 mr-md-1 mb-0 order-3 order-lg-1 ${disabled ? "text-gray" : "text-secondary"}`}>
                        {lifeAssuredName}
                        <span className='text-dark ml-1 mb-0'>
                          {age}
                          <span className='font-weight-light ml-1 mb-0'>yrs</span>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              )
            }
          >
            {this.houseWifeMsg() &&
              <div className='mb-0 mt-1'>
                <span className='max-cover-amount-msg'>
                  Housewife connot become the Proposer for Husband, please select a new Proposer.
                </span>
              </div>
            }

            <React.Fragment>
              {!Array.isArray(data.BI) ? (
                <div>
                  <AllProducts productName={productName} data={data} cardKey={cardKey} onAddMember={onAddMember} onAddInsured={onAddInsured} />
                </div>
              ) : data.BI.length > 0 ? (
                <ProductTabComponent data={data} cardKey={cardKey} onAddMember={onAddMember} onAddInsured={onAddInsured} showBackDropFunction={this.showBackDropFunction}
                  hideBackDropFunction={this.hideBackDropFunction}
                  showModalBackDrop={this.state.showModalBackDrop}
                  onTabSelected={this.riskTypeFunction}
                />
              ) : (!Array.isArray(data.BI) && data?.update_BI && productName) && (
                <div className='max-cover-amount-msg'>
                  {this.infoMessageFunction(this.props.title, lifeAssuredName) || 'No right match found. Kindly re-evaluate'}
                </div>
              )}
            </React.Fragment>
          </Collapse>


          {(totalPremium && !productData.isErrorExist && !isObjectEmpty(data.BI) && !isProductDisabled && this.state.isCollpaseOpen) && <TotalPremium {...totalPremium} productData={productData} paymenOptionPR={paymenOptionPR}/>}
          <ChangeProductReasonModal
            show={OptimizationStore.isReasonModalOpen}
            data={data}
          />
          {OptimizationStore.isChangeProductModalOpen &&
            <ChangeProductModal
              show={OptimizationStore.isChangeProductModalOpen}
              data={data}
              cardKey={cardKey}
            />
          }
        </>
      );
    }
  }
);

export default MemberCard;
